const STAND_PATH = 'http://192.168.56.103:8092/';
const API_PATH = 'api/v1/';
const WEB_PATH = 'web/';
const UI_PATH = 'ui';

const getBasePath = () => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}`;
};

const getApiPath = () => {
  if (process.env.BUILD_MODE === 'production') {
    return `${getBasePath()}/${API_PATH}`;
  }
  return `${STAND_PATH}/${API_PATH}`;
};

const getWebPath = () => {
  if (process.env.BUILD_MODE === 'development') {
    return `${STAND_PATH}/${WEB_PATH}`;
  }
  return '';
};

const getLoginParams = () => ({
  username: 'u1',
  password: '12345'
});

const getUIPath = () => {
  if (process.env.BUILD_HOST === 'true') return 'http://localhost:8090';
  if (process.env.BUILD_MODE === 'development') return getBasePath();
  return `${getBasePath()}/${UI_PATH}`;
};

const StandUtils = {
  getApiPath,
  getBasePath,
  getWebPath,
  getLoginParams,
  getUIPath
};
export default StandUtils;



// WEBPACK FOOTER //
// ./src/utils/standUtils.js